import React, { useState, useEffect } from 'react';
import { Outlet, useMatches } from 'react-router-dom';
import Header from './header';
import Sidebar from './sidebar';

export default function Layout() {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Get route metadata from the current matching route
  const matches = useMatches();
  const routeHandle = matches.find((match) => match.handle)?.handle || {};

  // Get title and subtitle from route metadata or use defaults
  const title = routeHandle.title || 'Dashboard';
  const subtitle = routeHandle.subtitle || 'Welcome to Campus Manager';

  // Check if we're on mobile device
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkScreenSize();

    // Add event listener for resize
    window.addEventListener('resize', checkScreenSize);

    console.log('This is the routehandle ', routeHandle.subtitle);
    console.log('Matches ', matches);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Close sidebar when navigating on mobile
  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  }, [matches, isMobile]);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {/* Backdrop overlay when sidebar is open on mobile */}
      {isMobile && sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-20 backdrop-blur-sm transition-opacity"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar component with visibility state */}
      <Sidebar
        isMobile={isMobile}
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
      />

      <div className="flex flex-1 flex-col overflow-hidden">
        <Header
          title={title}
          subtitle={subtitle}
          isMobile={isMobile}
          toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
        />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
